import { useMutation, useQuery } from "@tanstack/react-query";
import { fetch3, fetch4, fetch5 } from "../commonApis/commonApis";
import {
  addPromo,
  promoUpdate,
  setPromoList,
} from "../features/promo/promoSlice";
import { useDispatch } from "react-redux";
const url = process.env.REACT_APP_BASE_URL;

interface ApiResponse {
  success: boolean;
  data: any;
  message?: string;
}

// Create Product API

export const useItemPromoCreateMutation = () => {
  const dispatch = useDispatch();
  return useMutation({
    mutationFn: async (payload: any) => {
      const res: ApiResponse = await fetch4(`${url}/api/promo/`, payload);

      if (!res.success) {
        throw res.message || "Something went wrong";
      }

      return res.data;
    },
    onSuccess: (data: any) => {
      console.log("✅ Promo Created successfully:", data);
      dispatch(addPromo(data));
    },
    onError: (error: any) => {
      console.error("❌ Promo create request failed:", error.message);
    },
  });
};

export const usePromoUpdateMutation = () => {
  const dispatch = useDispatch();
  return useMutation({
    mutationFn: async ({
      id,
      ...payload
    }: {
      id: string;
      [key: string]: any;
    }) => {
      const res: ApiResponse = await fetch5(
        `${url}/api/promo/${id}`,
        "PUT",
        payload
      );

      if (!res.success) {
        throw res.message || "Something went wrong";
      }
      dispatch(promoUpdate(res.data));
      return res.data;
    },
    onSuccess: (data: any) => {
      console.log("✅ Promo updated successfully:", data);
    },
    onError: (error: any) => {
      console.error("❌ Promo update failed:", error.message);
    },
  });
};

// List Fatch Data
export const useFetchPromoItemData = (
  page: number,
  limit: number,
  searchFor: string
) => {
  const dispatch = useDispatch();
  return useQuery({
    queryKey: ["itemPromoData", page, limit, searchFor],
    queryFn: async () => {
      const res = await fetch3(
        `${url}/api/promo?page=${page}&limit=${limit}&searchFor=${searchFor}&type=LM`,
        "get"
      );

      if (!res || !res.data) {
        return res.message;
      }
      dispatch(setPromoList(res.data));
      return res.data;
    },
    staleTime: 1000 * 60 * 5,
  });
};

// All Product Fetch Data

export const useProductAllListData = () => {
  return useQuery({
    queryKey: ["productAllList"],
    queryFn: async () => {
      const res = await fetch3(`${url}/api/product-item/all`, "get");

      if (!res || !res.data) {
        return res.message;
      }

      return res.data;
    },
    staleTime: 1000 * 60 * 5,
  });
};

export const useProductListDataById = (id: any) => {
  return useQuery({
    queryKey: ["productListDataById", id],
    queryFn: async () => {
      if (!id) return [];
      const res = await fetch3(`${url}/api/product-item/all?clientId=${id}`, "get");

      if (!res || !res.data) {
        return [];
      }

      return res.data;
    },
    enabled: !!id,
    staleTime: 1000 * 60 * 5,
  });
};

// Status Update
interface UpdateItemPromoStatusPayload {
  id: string;
  status: any;
}

export const useUpdatePromoItemStatus = () => {
  return useMutation({
    mutationFn: async ({ id, status }: UpdateItemPromoStatusPayload) => {
      const res: ApiResponse = await fetch5(
        `${url}/api/promo/${id}/status`,
        "PATCH",
        {
          status,
        }
      );

      if (!res.success) {
        throw new Error(res.message || "Failed to update vehicle status");
      }

      return res.data;
    },
    onSuccess: (data: any) => {
      console.log("✅ Promo status updated successfully:", data);
    },
    onError: (error: any) => {
      console.error("❌ Promo status update failed:", error.message);
    },
  });
};
